import "./AddUserToSite.html";

import "../../../Forms/FindAddUser/FindAddUserComponent";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AddUserToSiteComponentController from "./AddUserToSiteComponentController";

export class AddUserToSiteComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddUserToSiteComponentController;
        this.templateUrl = "/App/Components/Site/UsersList/AddUserToSite/AddUserToSite.html";
    }
}

module("mmManagePortal").component("mmAddUserToSite", new AddUserToSiteComponent());
